class CartBackButton extends HTMLElement {
  connectedCallback () {
    this.cleanupFuncs = []

    this.cartEl = this.closest('[data-section-id="cart"]')
    this.buttonEl = this.querySelector('button')

    this.handleButtonClick = this.handleButtonClick.bind(this)

    this.handleEvents()
  }

  disconnectedCallback () {
    this.destroyEvents()
  }

  destroyEvents () {
    this.cleanupFuncs.forEach(func => {
      if (typeof func === 'function') {
        func.call(this)
      }
    })
  }

  handleEvents () {
    this.buttonEl?.addEventListener('click', this.handleButtonClick)

    this.cleanupFuncs.push(() => this.buttonEl?.removeEventListener('click', this.handleButtonClick))
  }

  handleButtonClick () {
    this.cartEl?.dispatchEvent(new CustomEvent('cart:back-from-gift'))
  }
}

customElements.define('cart-back-button', CartBackButton)
